export const SCALE_CURRENCY = 100;

const isValidAmount = amount => {
    return amount !== undefined && amount !== null && !Number.isNaN(amount);
};

export const formatCurrency = ({ amount, locale, currency }) => {
    if (!isValidAmount(amount)) {
        return null;
    }

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    });

    return formatter.format(amount / SCALE_CURRENCY);
};
